import globalConfirmPromptReducer from '@features/Prompt/globalConfirmPromptSlice.ts';
import notificationReducer from '@features/Prompt/notificationSlice.ts';
import { type Action, configureStore, type ThunkAction } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { entrySplitApi } from './entryApi.ts';
import appReducer from './reducers/appSlice.ts';
import authReducer from './reducers/authSlice.ts';
import studentAuthReducer from './reducers/studentAuthSlice.ts';
import trainerAuthReducer from './reducers/trainerAuthSlice.ts';

export const store = configureStore({
  reducer: {
    // Add the generated reducer as a specific top-level slice
    [entrySplitApi.reducerPath]: entrySplitApi.reducer,
    auth: authReducer,
    studentAuth: studentAuthReducer,
    trainerAuth: trainerAuthReducer,
    app: appReducer,
    globalConfirmPrompt: globalConfirmPromptReducer,
    notification: notificationReducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(entrySplitApi.middleware),
});

setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
